import { fdeEntryApi } from 'src/api';
import { defaultInstance } from 'src/api/instance';
import { configVars, getConfigVars } from 'src/helpers';
import { EntryReviewEscalationRequestType } from 'src/ts/interfaces';

const apiUrl = getConfigVars(window.location.hostname).api_url;

export type PlatformFeedbackCategory =
  | 'document_will_not_load'
  | 'page_error'
  | 'functionality_broken'
  | 'something_else';

// Hand-rolled: the generated SDK has no method for this endpoint.
export type ReportPlatformFeedbackRequest = {
  platform_feedback: {
    product_area: 'manual_review';
    entry_id: string;
    category: PlatformFeedbackCategory;
    feedback: string;
    can_complete_review: boolean;
    proof_id?: string;
  };
};

export type PlatformFeedbackReviewOutcome = 'kept' | 'released' | 'already_released';

export type ReportPlatformFeedbackResponse = {
  review: PlatformFeedbackReviewOutcome;
};

export type SpecialtyQueuePendingCountResponse = {
  data?: {
    pending_count?: number;
  };
};

const api = {
  getSocketToken: () => {
    return defaultInstance.get(`${configVars.server_url}/auth/socket_token`);
  },
  getPendingReviewEntry: () => {
    return fdeEntryApi.getReviewPendingEntry();
  },
  assignEntryRequest: () => {
    return fdeEntryApi.getEntryForReview();
  },
  cancelEntryRequest: () => {
    return defaultInstance.post(`${apiUrl}/entries/cancel_request`);
  },
  getSpecialtyQueuePendingCount: () => {
    return defaultInstance.get(
      `${apiUrl}/income_verifications/specialty-queue/pending-count`
    ) as unknown as Promise<SpecialtyQueuePendingCountResponse>;
  },
  escalate(entryId: string, data: EntryReviewEscalationRequestType) {
    return fdeEntryApi.escalateEntry(entryId, data);
  },
  reportPlatformFeedback(data: ReportPlatformFeedbackRequest) {
    return defaultInstance.post(
      `${apiUrl}/platform_feedback`,
      data
    ) as unknown as Promise<ReportPlatformFeedbackResponse>;
  }
};

export default api;
